module.exports = __webpack_public_path__ + "img/PSI.b5237138.svg";